import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { IGetRequestObject, ITrainingComplianceSummary } from '../../interfaces'

type QueryObject = {
  asOfDate?: string
}

const getTrainingComplianceSummaryRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/training/compliance/summary${queryString}`,
  }
}

const useTrainingComplianceSummaryQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingComplianceSummary | undefined
>({
  getRequest: getTrainingComplianceSummaryRequest,
  getQueryKey: (params, queryObject) => [
    'training-compliance-summary',
    queryObject?.asOfDate
  ],
})

const useTrainingComplianceSummaryQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingComplianceSummary | undefined, Error>,
) => {
  const trainingComplianceSummaryQuery = useTrainingComplianceSummaryQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingComplianceSummaryQuery }
}

export default useTrainingComplianceSummaryQuery